import { Effect, pipe, Option } from "effect";
import { CmcClientError, CmcToken, CmcTokenWithPrice, Quotes } from "./types";
import { request } from "./request";

export type GetTokenPrice = ReturnType<typeof getTokenPrice>;
export type GetTokenPriceSuccess = Effect.Effect.Success<GetTokenPrice>;
export type GetTokenPriceError = Effect.Effect.Error<GetTokenPrice>;
export type GetTokenPriceContext = Effect.Effect.Context<GetTokenPrice>;

export function getTokenPrice(tokens: CmcToken[]) {
  return Effect.gen(function* () {
    const ids = tokens.map((token) => token.meta.id).join(",");
    const endpoint = `/v2/cryptocurrency/quotes/latest?id=${ids}` as const;

    const { data } = yield* request(endpoint, Quotes);

    const tokensWithPrice: CmcTokenWithPrice[] = yield* Effect.forEach(
      tokens,
      (token) => {
        const { meta, tokenAddress } = token;

        return pipe(
          data[meta.id],
          Option.fromNullable,
          Option.map((quote) => quote.quote.USD.price),
          Effect.mapError(
            (cause) =>
              new CmcClientError({
                cause,
                message: `Missing quote for ${tokenAddress}`,
              })
          ),
          Effect.map((priceUsd): CmcTokenWithPrice => ({ ...token, priceUsd }))
        );
      }
    );

    return tokensWithPrice;
  });
}
